import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NdmsNavComponent} from "./ndms-nav/ndms-nav.component";
import {UsersModule} from "../../components/users/users.module";
import {AppRoutingModule} from "../../app-routing.module";
import {TreeModule} from 'primeng/tree';
import {TreeNode} from 'primeng/api';
import {PanelModule} from 'primeng/panel';
import {TableModule} from 'primeng/table';
import {PickListModule} from 'primeng/picklist';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ButtonModule} from 'primeng/button';
import { TextMaskModule } from 'angular2-text-mask';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { PasswordExpirationNotificationComponent } from './password-expiration-notification/password-expiration-notification.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LoadingSpinnerService } from './loading-spinner/loading-spinner.service';
import {AuthApiService} from "../../../../projects/jpats/app/shared/core-jpats/services/auth.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {JpatsAuthRequestInterceptor} from "../../../../projects/jpats/app/shared/core-jpats/interceptors/auth-request.interceptor";
import {NdmsAuthRequestInterceptor} from "../../../../projects/shared/core/interceptors/ndms-auth-request.interceptor";

@NgModule({
  providers: [
    LoadingSpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NdmsAuthRequestInterceptor  ,
      multi: true
    }
  ],
  declarations: [
    NdmsNavComponent,
    ProfileEditComponent,
    PasswordExpirationNotificationComponent,
    LoadingSpinnerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    TextMaskModule
  ],
  exports:[
    NdmsNavComponent,
    TreeModule,
    PanelModule,
    TableModule,
    PickListModule,
    TieredMenuModule,
    ButtonModule
  ],
  entryComponents: [
    ProfileEditComponent,
    PasswordExpirationNotificationComponent,
    LoadingSpinnerComponent
  ]
})
export class CoreUiModule { }
